import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { BulkUpdateTasks } from '../../redux/taskSlice';
import { Menu, MenuTrigger, MenuPopover, MenuList, MenuItem } from '@fluentui/react-components';
import { ChevronDown12Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';

const BulkStatusUpdateMenu = ({ selectedRows, onBulkUpdateComplete, children }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    const handleBulkStatusChange = async status => {
        if (!selectedRows || selectedRows.length === 0) return;

        setIsUpdating(true);
        try {
            // Update all selected tasks with the new status using bulk update
            await dispatch(
                BulkUpdateTasks({
                    taskIds: selectedRows,
                    updates: { status: status },
                    suppressToast: true,
                }),
            );

            // Call the completion callback
            if (onBulkUpdateComplete) {
                onBulkUpdateComplete(status, selectedRows.length);
            }

            setOpen(false);
        } catch (error) {
            console.error('Error updating bulk task status:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <Menu open={open} onOpenChange={(e, data) => setOpen(data.open)}>
            <MenuTrigger>
                {children || (
                    <div className={styles.bulkUpdateMenu} style={{ opacity: isUpdating ? 0.6 : 1 }}>
                        Status <ChevronDown12Regular className="ms-1" />
                    </div>
                )}
            </MenuTrigger>
            <MenuPopover style={{ width: '118px', minWidth: '118px' }}>
                <MenuList>
                    <MenuItem
                        className={styles.statusMenuItem}
                        onClick={() => handleBulkStatusChange('COMPLETED')}
                        style={{ backgroundColor: 'var(--RAG-Green)', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        Completed
                    </MenuItem>
                    <MenuItem
                        className={styles.statusMenuItem}
                        onClick={() => handleBulkStatusChange('WORKING_ON_IT')}
                        style={{ backgroundColor: 'var(--RAG-Amber)', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        Working on it
                    </MenuItem>
                    <MenuItem
                        className={styles.statusMenuItem}
                        onClick={() => handleBulkStatusChange('STUCK')}
                        style={{ backgroundColor: 'var(--RAG-Red)', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        Stuck
                    </MenuItem>
                    <MenuItem
                        className={styles.statusMenuItem}
                        onClick={() => handleBulkStatusChange('NOT_STARTED')}
                        style={{ backgroundColor: '#C0C6D8', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        Not Started
                    </MenuItem>
                    <MenuItem
                        className={styles.statusMenuItem}
                        onClick={() => handleBulkStatusChange('CANCELLED')}
                        style={{ backgroundColor: '#6B6F89', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        Cancelled
                    </MenuItem>
                    <MenuItem
                        className={styles.statusMenuItem}
                        onClick={() => handleBulkStatusChange('ON_TRACK')}
                        style={{ backgroundColor: '#4F8A6F', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        On Track
                    </MenuItem>
                    <MenuItem
                        className={styles.statusMenuItem}
                        onClick={() => handleBulkStatusChange('OFF_TRACK')}
                        style={{ backgroundColor: '#9E4F4F', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        Off Track
                    </MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default BulkStatusUpdateMenu;
